module.exports = __webpack_public_path__ + "media/images/lamp/turned_off-68cd82d17b4a1923f937f31516994a7f.png";